(function () {
  const cartDrawer = document.querySelector('cart-drawer');

  cartDrawer.addEventListener('mousedown', function (event) {
    const gwpModal = document.querySelector('.gwp-modal');

    const actionButton = event.target.closest('[data-gwp-action]');
    if (actionButton) {
      if (actionButton.getAttribute('data-gwp-action') === 'modal-open') {
        gwpModal.classList.remove('hidden');
        loading = false;
        return;
      } else if (actionButton.getAttribute('data-gwp-action') === 'modal-close') {
        gwpModal.classList.add('hidden');
        loading = false;
        return;
      } else if (actionButton.getAttribute('data-gwp-action') === 'select-gift') {
        const giftLines = cartDrawer.querySelectorAll('.gwp-modal__gift');

        giftLines.forEach((gift) => {
          gift.setAttribute('disabled', 'disabled');
          const addGiftBtn = gift.querySelector('.gwp-modal__gift-cta');

          if (addGiftBtn) {
            addGiftBtn.setAttribute('disabled', 'disabled');
          }
        });

        const giftId = actionButton.getAttribute('data-gwp-gift-id');
        const giftPromoEnd = actionButton.getAttribute('data-gwp-promotion-end');
        const props = {
          _is_gift: true,
          _gift_id: Date.now() + '_' + giftId,
          _is_autoadd: event.detail ? event.detail.gwpAutoadd : false,
          _promotion_end: giftPromoEnd,
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: giftId,
                quantity: 1,
                properties: props,
              },
            ],
          }),
        })
          .then((response) => response.json())
          .then(() => {
            // Used to open the cart drawer if it's closed and if we're adding products from PDPs and PLPs
            /* const cartDrawer = document.querySelector('cart-drawer');
            const cartButton = document.querySelector('.header__icon--cart');

            if (cartDrawer && cartButton && !cartDrawer.classList.contains('active')) {
              cartButton.click();
            } */

            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gwp' });
          });
      }
    }
  });
})();
